export class NgCamMirrorProperties {
  public x: string;  // ["auto", "always", "never"]
}
